import { AfterViewInit, Component, computed, ElementRef, HostListener, inject, signal, ViewChild } from '@angular/core';
import { MemberInfo } from '../../../interfaces/app.interface';
import { advisorsList, membersList } from '../../../lists/members-list';
import { AppService } from '../../../services/app.service';
import { TranslatePipe } from '@codeandweb/ngx-translate';

@Component({
  selector: 'app-members',
  imports: [TranslatePipe],
  templateUrl: './members.html',
  styleUrl: './members.scss'
})
export class Members implements AfterViewInit {
  @ViewChild('memberDiv') memberDiv!: ElementRef<HTMLDivElement>;
  public appService = inject(AppService);
  public memberWidth = signal<number>(0);
  protected readonly memberList = computed<MemberInfo[]>(() => {
    const language = this.appService.usedLanguage();

    const member = membersList.find(member => member.language === language);

    return member?.list ?? [];
  });
  protected readonly advisorList = computed<MemberInfo[]>(() => {
    const language = this.appService.usedLanguage();

    const member = advisorsList.find(member => member.language === language);

    return member?.list ?? [];
  });

  ngAfterViewInit() {
    setTimeout(() => {
      this.syncMemberWidth();
    }, 0);
  }

  @HostListener('window:resize')
  onResize() {
    this.syncMemberWidth();
  }

  goToLinkedIn(site: string) {
    window.open(site, '_blank');
  }

  syncMemberWidth() {
    if (!this.memberDiv) return;
    this.memberWidth.set(this.memberDiv.nativeElement.offsetWidth);
  }
}
